<template>
  <div class="form-signin col-md-4 mx-auto mt-5 text-center">
    <img
      class="mb-4"
      src="../../assets/img/deepify.png"
      alt=""
      width="72"
      height="72"
    >
    <h1 class="h3 mb-3 font-weight-normal">
      Please sign in
    </h1>
    <label
      for="inputEmail"
      class="sr-only"
    >Email address</label>
    <input
      id="inputEmail"
      v-model="email"
      type="email"
      class="form-control mb-1"
      placeholder="Email address"
      required=""

      autofocus=""
    >
    <label
      for="inputPassword"
      class="sr-only"
    >Password</label>
    <input
      id="inputPassword"
      v-model="password"
      type="password"
      class="form-control mb-3"
      placeholder="Password"

      required=""
    >
    <button
      class="btn btn-lg btn-dark btn-block mb-2"
      type="submit"

      @click="login"
    >
      Sign in
    </button>
    <small>or</small>
    <router-link
      to="/signup"
      class="button button--link button--link-primary"
    >
      <h6 class="mt-2 text-dark">
        Sign up for an account
      </h6>
    </router-link>
    <p class="mt-5 mb-3 text-muted">
      © 2019
    </p>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions([
      'doLogin',
      'fetchToken',
    ]),
    login() {
      if (this.email && this.password) {
        this.doLogin({
          email: this.email,
          password: this.password,
        });
      }
    },
    created() {
      this.fetchToken();
    },
  },
};
</script>
